import styled from 'styled-components'
import { Flex } from '@mantine/core'
import { smStyle, mdStyle, lgStyle } from '@/components/Adapter'

export const PriceFutureStyled = styled.div`
  border-right: none;

  ${mdStyle} {
    padding-right: 16px;
    border-right: 1px solid var(--color-divider-2);
  }

  ${lgStyle} {
    padding-right: 24px;
    border-right: 1px solid var(--color-divider-2);
  }
`

export const PriceFutureTitle = styled.h2`
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  font-size: 20px;

  ${smStyle} {
    font-size: 24px;
  }
`

export const PriceFutureContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const PriceFutureItemBox = styled.div`
  display: flex;
  flex-direction: column;
`

export const FutureEventItemStyled = styled.li`
  list-style: none;

  &[data-border='true'] {
    border-bottom: 1px solid var(--color-divider-2);
  }
`

export const PriceFutureItemFlex = styled(Flex)`
  padding: 21.5px 0px 21.5px 12px;
  gap: 24px;
  align-items: flex-start;
  flex-direction: column;

  ${smStyle} {
    flex-direction: row;
  }
`
const TodaySvgStyled = styled.span`
  display: block;
  position: relative;

  > i {
    width: 36px;
    position: absolute;
    top: 13px;
    left: 0;
    right: 0;
    text-align: center;
    color: var(--color-brand-1);
    font-size: 20px;
    font-weight: 600;
    font-style: normal;
  }
  svg {
    width: 36px;
    height: 36px;
  }
`

export const MarketCoinStyled = styled.div`
  display: none;
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid var(--color-divider-2);
  background-color: var(--color-bg-1);
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  flex-shrink: 0;
  cursor: pointer;
  box-sizing: border-box;
  height: 24px;

  ${mdStyle} {
    display: flex;
  }
`

export const CoinNameLabelStyled = styled.span`
  color: var(--color-text-1);
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
`

export const CoinChangeNameStyled = styled(CoinNameLabelStyled)`
  font-weight: 500;
`

export const TodaySvg = ({ day, isDark }: { day: string; isDark: boolean }) => {
  return (
    <TodaySvgStyled>
      <i>{day}</i>
      <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_1240_34799)">
          <rect x="0.5" y="4.5" width="35" height="31" rx="1.5" stroke="#2354E6" />
          <path d="M0 6C0 4.89543 0.895431 4 2 4H33C34.1046 4 35 4.89543 35 6V13H0V6Z" fill="#2354E6" />
          <rect
            x="8.5"
            y="7.5"
            width="7"
            height="4"
            rx="2"
            transform="rotate(-90 8.5 7.5)"
            fill="#2354E6"
            stroke={isDark ? '#141414' : 'white'}
          />
          <rect
            x="23.5"
            y="7.5"
            width="7"
            height="4"
            rx="2"
            transform="rotate(-90 23.5 7.5)"
            fill="#2354E6"
            stroke={isDark ? '#141414' : 'white'}
          />
          {/* 数字 31 */}
          {/* <path
            d="M14.96 23.36C15.7733 23.6667 16.3933 24.12 16.82 24.72C17.2467 25.3067 17.46 26.04 17.46 26.92C17.46 27.8267 17.2267 28.6067 16.76 29.26C16.3067 29.9 15.6867 30.3933 14.9 30.74C14.1267 31.0733 13.2667 31.24 12.32 31.24C11.1067 31.24 10.0467 30.9533 9.14 30.38C8.24667 29.8067 7.61333 28.9733 7.24 27.88L9.54 26.56C9.75333 27.2533 10.1067 27.78 10.6 28.14C11.0933 28.4867 11.6467 28.66 12.26 28.66C12.86 28.66 13.36 28.4867 13.76 28.14C14.1733 27.7933 14.38 27.3133 14.38 26.7C14.38 25.3533 13.3533 24.68 11.3 24.68H10.76V22.28H11.54C12.3 22.28 12.88 22.1 13.28 21.74C13.6933 21.3667 13.9 20.9067 13.9 20.36C13.9 19.8533 13.7333 19.4467 13.4 19.14C13.0667 18.8333 12.6333 18.68 12.1 18.68C11.5267 18.68 11.0267 18.8667 10.6 19.24C10.1867 19.6 9.86667 20.12 9.64 20.8L7.44 19.54C7.78667 18.42 8.39333 17.5667 9.26 16.98C10.1267 16.38 11.1533 16.08 12.34 16.08C13.26 16.08 14.0667 16.2533 14.76 16.6C15.4667 16.9333 16.0133 17.4067 16.4 18.02C16.7867 18.6333 16.98 19.34 16.98 20.14C16.98 20.8867 16.8067 21.5333 16.46 22.08C16.1267 22.6267 15.6267 23.0533 14.96 23.36ZM20.2717 21.66V18.88L24.7517 16.34H27.0117V31H24.0717V19.54L20.2717 21.66Z"
            fill="#2354E6"
          /> */}
        </g>
        <defs>
          <clipPath id="clip0_1240_34799">
            <rect width="36" height="36" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </TodaySvgStyled>
  )
}
